import React from 'react';

// React Router
import { useHistory } from 'react-router-dom';

// Base Layout Components
import { TJPageHeader, TJCTACard, TJHeader, TJLoader } from 'tj-components';
import Grid from '@mui/material/Grid';

// Data import
import apis from '../helpers/apis';

const IPGHomePage = () => {
  const history = useHistory();
  const currentApi = apis.filter(
    (api) =>
      api.name === 'Direct Intergration' || api.name === 'Hosted Payment Page'
  );

  return (
    <Grid container spacing={0} xs={12}>
      <div className="tj-main">
        <Grid
          container
          spacing={2}
          justifyContent="flex-start"
          className="container selection-cards"
        >
          {currentApi.map((api, index) => {
            return (
              <Grid
                item
                xs={12}
                md={4}
                lg={4}
                lx={4}
                key={index}
                style={{ display: 'flex' }}
                onClick={() =>
                  history.push({
                    pathname: `/${api.slug}`,
                  })
                }
              >
                <TJCTACard
                  width="100%"
                  title={api.name}
                  height="auto"
                  minWidth="150px"
                  maxWidth="auto"
                  description={api.excerpt}
                  iconClass={api.icon}
                />
              </Grid>
            );
          })}
        </Grid>
      </div>
    </Grid>
  );
};

export default IPGHomePage;
